import fetch from '@/utils/fetch'
import { Response } from './types'

export interface NewUserCouponsReq {
  /**
   * 国家
   */
  countryCode: string
  /**
   * 币种,默认HKD
   */
  currencyCode?: string
  language: string
  /**
   * 券活动类型: 1:新人专项 2:全量用户 3:新人礼包
   */
  marketingType: number
  uniqueMark: string
}

// 领券接口 返回优惠券信息
export const receiveCoupon = (body: NewUserCouponsReq, headers: any = {}): Promise<Response> =>
  fetch.post({
    url: '/api/v1/h5/adapter/coupon/oversea/drawCouponH5List',
    headers,
    data: body,
  })
